import { getRequest } from 'lib/api/api'
import { getImsxDescription } from 'lib/api/utils'
import { useEffect, useState } from 'react'
import { TrustedAppRating } from '../models/ITrustedApplication'

interface IPublicApplication {
  rating?: TrustedAppRating
  logo?: string
  privacyUrl?: string
  title: string
}

interface UseQueryPublicApplicationsOptions {
  orgId: string | number
}

export function useQueryPublicApplications({
  orgId,
}: UseQueryPublicApplicationsOptions) {
  const [loading, setLoading] = useState(false)
  const [applications, setApplications] = useState<IPublicApplication[]>([])
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setLoading(true)

    getRequest(`trustedapps/public/organizations/${orgId}/applications`, {
      sort: 'rating:ascending',
    })
      .then((res) => {
        if (res.success) {
          setApplications(res.data.applications)
        } else {
          setError(getImsxDescription(res) || res.data?.message || 'An error occurred.')
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }, [orgId])

  return { data: applications, loading, error }
}
